/* istanbul ignore file */
import { useState } from 'react'

import { useFinishRegistration } from '@plugins/Partners/GEB/loaders/registration'
import { useParams } from '@stores/params'

interface ShowSignInScreenArgs {
  locale?: string
  startScreen?: 'gigya-login-screen' | 'gigya-register-screen'
  onError: (err: Error) => void
  onAfterSubmit: (res: { regToken: string; loginToken: string; memberId: string }) => void
}

export const showSignInScreen = (args: ShowSignInScreenArgs): void => {
  window.gigya?.accounts.showScreenSet({
    communicationLangByScreenSet: true,
    lang: 'es-mx',
    screenSet: 'Default-RegistrationLogin',
    startScreen: args.startScreen,
    onError: (err: Error) => {
      args.onError(err)
    },
    onAfterSubmit: (res: any) => {
      //TODO: add types in upcoming PR
      const regToken = res?.response?.requestParams?.regToken
      const loginToken = res?.response?.sessionInfo?.login_token
      const memberId = res?.response?.UID
      args.onAfterSubmit({ regToken, loginToken, memberId }) //NOTE: loginToken kept for future purposes.
    },
  })
}

interface UseGigyaSignInScreenArgs extends ShowSignInScreenArgs {}

export const useGigyaSignInScreen = (args?: UseGigyaSignInScreenArgs) => {
  const [{ locale, retailerPartnerNumber }] = useParams()
  const finishRegistrationMutation = useFinishRegistration()
  const [error, setError] = useState<Error | null>(null)

  const showUIAuthHandler = (startScreen?: ShowSignInScreenArgs['startScreen']) => {
    return showSignInScreen({
      locale,
      startScreen: startScreen ?? 'gigya-login-screen',
      onError: error => {
        console.error('Show signin screen error:', error)
        setError(error)
        args?.onError?.(error)
      },
      onAfterSubmit: ({ regToken, memberId }) => {
        // needs to call the endpoint to make the regToken
        if (!regToken) {
          return
        }
        const finishRegistrationPayload = {
          retailerPartnerNumber,
          memberId: memberId ?? '',
          body: {
            reg_token: regToken,
          },
        }
        finishRegistrationMutation.mutate(finishRegistrationPayload, {
          onSuccess: data => {
            if (data?.status === 'success') {
              console.log('Registration successful:', data)
            }
          },
        })
      },
    })
  }

  return { showUIAuthHandler, error }
}
